import { checkSignupAgeQuery } from '~/graphql/documents/core';

export const useSignupAgeCheck = () => {
  const { $urqlClient } = useNuxtApp();
  const { t } = useI18n();

  const check = async (birthMonthYear: string): Promise<{ canCreateAccount: boolean; canBeMarketed: boolean; error: string | null }> => {
    const res = await $urqlClient.query(checkSignupAgeQuery, { birthMonthYear }, { requestPolicy: 'network-only' }).toPromise();
    const result = res.data?.core.site.checkSignupAge;

    if (res.error || !result) {
      return {
        canCreateAccount: false,
        canBeMarketed: false,
        error: res.error ? getFirstErrorMessageFromCombinedErrors(t, res.error) : t('general.unexpectedError'),
      };
    }

    return { canCreateAccount: result.canCreateAccount, canBeMarketed: result.canBeMarketed, error: null };
  };

  return { check };
};
